import urls from './urls';
import { axiosPost, axiosPut, getSourceId } from './common';
import { NO, YES } from '../constants';
import { addAnalyticEvent } from '../analytics/common';
import {
  emailRetrievePageLoadError,
} from '../analytics/email';
import {
  LOCAL_AD_TYPE, PRO_TYPE,
  PROMOTIONS_TYPE,
  RETARGETING_TYPE, SBOTD_TYPE,
  SURVEYS_TYPE
} from '../components/tableData';

export function retrieveEmailPreferences(emailAddress, callback, err) {
  const request = {
    emailAddress
  };

  const errorCallback = (error) => {
    addAnalyticEvent(emailRetrievePageLoadError);
    err(error);
  };

  axiosPost({
    url: urls.RETRIEVE_EMAIL,
    data: request,
    callback,
    err: errorCallback,
  });
}

function populatePreferences(selected, table) {
  return selected.map((row) => {
    const entry = table[row];
    return {
      type: entry.type,
      status: entry.value
    };
  });
}

export function updateEmailPreferences(emailAddress, subscriptions, table, callback, err) {
  const preferences = (table != null) ? populatePreferences(subscriptions, table) : subscriptions;
  const request = {
    sourceId: getSourceId(),
    emailAddress,
    subscriptions: preferences
  };

  axiosPut({
    url: urls.UPDATE_EMAIL,
    data: request,
    callback,
    err,
  });
}

export function unsubscribeEmail(email, callback, err) {
  const request = {
    sourceId: getSourceId(),
    emailAddress: email,
    globalOptOut: YES,
    subscriptions: [
      {
        type: RETARGETING_TYPE,
        status: NO
      }
    ]
  };

  axiosPut({
    url: urls.UPDATE_EMAIL,
    data: request,
    callback,
    err,
  });
}
export function unsubscribeSurveyEmail(email, callback, err) {
  const request = {
    sourceId: getSourceId(),
    emailAddress: email,
    subscriptions: [
      {
        type: SURVEYS_TYPE,
        status: NO
      }
    ]
  };

  axiosPut({
    url: urls.UPDATE_EMAIL,
    data: request,
    callback,
    err,
  });
}
